import { collection, query, where, getDocs, getFirestore, orderBy, limit } from "firebase/firestore";
import firebaseApp from "../firebase/credenciales";

const db = getFirestore(firebaseApp);

/**
 * Obtiene indicadores consolidados de planillas para el Dashboard
 * @param {Object} params - { rucEmpresa, year }
 * @returns {Promise<Object>} - Indicadores de planilla
 */
export async function obtenerIndicadoresPlanilla({ rucEmpresa, year }) {
    try {
        const planillasRef = collection(db, "pl_planillas");
        const q = query(
            planillasRef,
            where("ruc_empresa", "==", rucEmpresa),
            where("periodo", ">=", `${year}-01`),
            where("periodo", "<=", `${year}-12`),
            orderBy("periodo", "desc"),
            limit(12)
        );

        const snapshot = await getDocs(q);
        const planillas = [];

        snapshot.forEach(doc => {
            planillas.push({ id: doc.id, ...doc.data() });
        });

        // Ordenar por periodo ascendente para los gráficos
        planillas.sort((a, b) => a.periodo.localeCompare(b.periodo));

        const labels = planillas.map(p => p.periodo.split("-")[1]); // Solo el mes
        const dataNeto = planillas.map(p => p.total_neto || 0);
        const dataCostoTotal = planillas.map(p => p.costo_laboral_total || 0);
        const dataCargaPres = planillas.map(p => (p.total_aportaciones || 0) + (p.total_provisiones || 0));

        // Última planilla procesada (indicadores de tarjeta)
        const ultimaPlanilla = planillas[planillas.length - 1];

        return {
            hayDatos: planillas.length > 0,
            ultima: {
                periodo: ultimaPlanilla?.periodo || "N/A",
                costoLaboralTotal: ultimaPlanilla?.costo_laboral_total || 0,
                netoPagar: ultimaPlanilla?.total_neto || 0,
                cargaPrestacional: (ultimaPlanilla?.total_aportaciones || 0) + (ultimaPlanilla?.total_provisiones || 0),
                numEmpleados: ultimaPlanilla?.total_empleados || 0
            },
            chartData: {
                labels: planillas.map(p => {
                    const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SET", "OCT", "NOV", "DIC"];
                    const mesIdx = parseInt(p.periodo.split("-")[1]) - 1;
                    return meses[mesIdx];
                }),
                datasets: [
                    {
                        label: "Neto a Pagar",
                        data: dataNeto,
                        borderColor: "#4caf50",
                        backgroundColor: "rgba(76, 175, 80, 0.2)",
                        tension: 0.3,
                        fill: true
                    },
                    {
                        label: "Costo Laboral Total",
                        data: dataCostoTotal,
                        borderColor: "#f44336",
                        backgroundColor: "rgba(244, 67, 54, 0.2)",
                        tension: 0.3,
                        fill: true
                    }
                ]
            }
        };
    } catch (error) {
        if (error?.code === "permission-denied" || String(error?.message || "").includes("permissions")) {
            console.warn("obtenerIndicadoresPlanilla: Permisos insuficientes en Firestore para obtener indicadores de planilla.");
            return {
                hayDatos: false,
                ultima: {
                    periodo: "N/A",
                    costoLaboralTotal: 0,
                    netoPagar: 0,
                    cargaPrestacional: 0,
                    numEmpleados: 0
                },
                chartData: { labels: [], datasets: [] }
            };
        }
        console.error("Error al obtener indicadores de planilla:", error);
        throw error;
    }
}
